import { RootScope } from "../types/angular-types";
import './MigrateDataModalController'

interface IScope extends RootScope {
}

angular.module('GorillaBoy.directives')
    .directive('migrateDataBanner',
        [
            '$rootScope',
            'localStorageService',
            '$timeout',
            '$uibModal',
            ($rootScope, localStorageService, $timeout, $uibModal) => {
                return {
                    templateUrl: './migrate-data-banner/migrate_data_banner.html',
                    link: ($scope: IScope, element, attrs) => {
                        let modalHandle = null;
                        $rootScope.isMigrateDataBannerVisible().then((isVisible) => {
                            $scope.displayMigrateDataBanner = isVisible;
                            if (isVisible && $rootScope.displayMigrationModal) {
                                $rootScope.metricServiceInstance.newCounterMetric("DisplayedMigrateDataModal")
                                $timeout(() => {
                                    modalHandle = $uibModal.open({
                                        templateUrl: './migrate-data-banner/migrate_data_modal.html',
                                        controller: 'migrateDataModalCtrl',
                                        backdrop: 'static',
                                        keyboard: false,
                                        size: 'lg',
                                        windowClass: 'migrate-data-modal'
                                    });
                                    postProcessModalOpening(modalHandle);
                                }, 500);
                            }
                        });
                        function postProcessModalOpening(modalHandle) {
                            $scope.$on("$destroy", function() {
                                if (modalHandle) {
                                    modalHandle.close();
                                }
                            });
                        }
                    }
                };
            }
        ]
    )